import { Deserializable } from 'rome-library';

export class ForgottenPasswordResetRequestDto implements Deserializable {
  public Answer: string;
  public Password: string;
  public ConfirmPassword?: string;
  public QuestionCode?: string;
  public RequestGuid: string;

  public deserialize(input: any): this {
    Object.assign(this, input);

    return this;
  }
}
